import styled from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const DatePickerField = styled.div`
    width: 100%;
`;

export const Hr = styled.hr`
    width: 100%;
    height: 1px;
    border: 0;
    background: #ebebeb;
    margin: 20px 0;
`;
